export default __webpack_public_path__ + "static/media/rank-badge.992f9ffa.svg";